// PDF Preview Component Styles
export const containerStyles = {
  overflow: 'auto' as const,
  scrollBehavior: 'smooth' as const,
  paddingTop: '26px',
  height: '100%',
  borderTop: '1px solid #E5E7EB',
  '& .rpv-core__viewer': {
    border: 'none',
  },
  '& .rpv-core__viewer.rpv-core__viewer--light': {
    border: 'none',
    backgroundColor: '#F3F4F6',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  '& div[data-testid="core__inner-pages"], .rpv-thumbnail__list, .rpv-core__viewer': {
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
      backgroundColor: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#652DBF',
      borderRadius: '100px',
    },
  },
  '& .thumbnail__list': {
    marginBottom: '6px',
    backgroundColor: '#F3F4F6',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  '& .rpv-thumbnail__list': {
    flexFlow: 'column',
    justifyContent: 'flex-start',
  },
  '& .rpv-thumbnail__list > div': {
    margin: '2.5px 0',
  },
  '& .rpv-thumbnail__item': {
    padding: '5px',
    '& .rpv-thumbnail__container': {
      borderRadius: '5px',
      overflow: 'hidden',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    },
  },
  '& .rpv-core__inner-page': {
    backgroundColor: '#F3F4F6',
    '& .rpv-core__page-layer': {
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    },
  },
  '& .rpv-thumbnail__item--selected, .rpv-thumbnail__item:focus, .rpv-thumbnail__item:hover': {
    background: '#E1CEFF',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
  },
  '& .rpv-thumbnail__index': {
    display: 'none',
  },
  '& .rpv-core__viewer.flex.h-full > .overflow-auto': {
    width: '269px',
  },
  '& .rpv-core__viewer.flex.h-full:last-child': {
    width: '100%',
  },
  '& .react-pdf__Page__canvas': {
    width: '100%!important',
    height: 'auto!important',
  },
  '& .react-pdf__Page__textContent, .react-pdf__Page__annotations': {
    display: 'none!important',
  },
  '.react-pdf__Document .react-pdf__Page canvas.react-pdf__Page__canvas': {
    padding: '4px',
    paddingTop: '0px',
    paddingRight: '0px',
  },
  '.react-pdf__Document': {
    paddingY: '4px',
  },
} as const;
